import type * as React from "react";
import { Group, type GroupProps } from "react-aria-components";
import { type DisplayVariants, base } from "./Flex.css.ts";
import type { OmittedReactAriaProps } from "./types.ts";

interface Props
  extends Omit<GroupProps, OmittedReactAriaProps>, DisplayVariants {
  children: React.ReactNode;
  style?: Record<string, string | number>;
  ref?: React.Ref<HTMLDivElement>;
}

export const Flex: React.FC<Props> = ({
  children,
  flexDirection = "row",
  gap,
  rowGap,
  columnGap,
  flexWrap = "nowrap",
  padding,
  paddingBottom,
  justifyContent,
  ...props
}) => {
  return (
    <Group
      {...props}
      className={base({
        flexDirection,
        gap,
        rowGap,
        columnGap,
        flexWrap,
        padding,
        paddingBottom,
        justifyContent,
      })}
    >
      {children}
    </Group>
  );
};
